import { useMatch } from 'react-router-dom';
import { RoutesEnum as AppRoutes } from '../../routes/RoutesEnum';

const useIsCampaignPageRoute = () => {
  const matchCampaign = useMatch(AppRoutes.CAMPAIGN);
  return matchCampaign;
};

export default useIsCampaignPageRoute;